import React from 'react'
import css from './style.scss'
import {Route} from 'react-router-dom';
import AdventurePage from 'components/account_page/adventures/adventure_page'
import store from 'utils/store'
import {push} from 'react-router-redux'

class Adventure extends React.Component{
  openPage=()=>{
    store.dispatch(push("/a/"+this.props.account.id+"/adventures/"+this.props.id))
  }
  render(){
    let style=this.props.stories.length>0 ? {"backgroundImage":"url('"+this.props.stories[0].thumb+"')"} : {}
    return (
      <div>
        <div onClick={this.openPage} className={css.adventure} style={style}>
          <div className={css.bar}>
            <div className={css.title}>{this.props.name}</div>
            <div className={css.subtitle}>{this.props.stories.length} Stories</div>
          </div>
        </div>
        <Route path={"/a/:id/adventures/"+this.props.id} render={routeProps=>(
          <AdventurePage {...routeProps}
            returnTo={"/a/"+this.props.account.id+"/adventures/"}
            {...this.props}
          />
        )} />

      </div>

    )

  }
}

export default Adventure;



// WEBPACK FOOTER //
// ./src/components/account_page/adventures/adventure.js